module.exports = __webpack_public_path__ + "img/icon-regex.40a68430.svg";